import React, { useState } from "react";
import InvertedLogo from "src/assets/inverted-logo.svg";
import { useForm } from "react-hook-form";
import { navigate } from "gatsby";
import { FaLongArrowAltRight } from "react-icons/fa";
import { Resend } from "resend";

export const ContactForm = () => {
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });

  const handleChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
  
    try {
      const response = await fetch('/api/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
  
      if (!response.ok) {
        throw new Error('Failed to send email');
      }
  
      alert('Email sent successfully!');
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        message: ''
      });
    } catch (error) {
      console.error('Error sending email:', error);
      alert('An error occurred while sending the email. Please try again later.');
    }
  };

  return (
    <>
      <section
        id="contact-form-section"
        className="lg:absolute -top-16 right-0 bg-orange h-[107.3%] lg:w-[35%] flex items-center flex-col py-12 px-8"
      >
        <img src={InvertedLogo} className="w-[75%]" />
        <form id="contact-form" className="w-full flex flex-col mt-16" onSubmit={handleSubmit}>
      <div className="grid grid-cols-2">
        <div className="single-input-holder col-span-2 lg:col-span-1 m-2">
          <input
            type="text"
            className="w-full p-3 text-orange placeholder:text-orange placeholder:font-secondary placeholder:uppercase"
            placeholder="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
        </div>
        <div className="single-input-holder col-span-2 lg:col-span-1 m-2">
          <input
            type="text"
            className="w-full p-3 text-orange placeholder:text-orange placeholder:font-secondary placeholder:uppercase"
            placeholder="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        <div className="single-input-holder col-span-2 lg:col-span-1 m-2">
          <input
            type="text"
            className="w-full p-3 text-orange placeholder:text-orange placeholder:font-secondary placeholder:uppercase"
            placeholder="Phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
          />
        </div>
        <div className="single-input-holder col-span-2 lg:col-span-1 m-2">
          <input
            type="text"
            className="w-full p-3 text-orange placeholder:text-orange placeholder:font-secondary placeholder:uppercase"
            placeholder="Company"
            name="company"
            value={formData.company}
            onChange={handleChange}
          />
        </div>
        <div className="single-input-holder col-span-2 m-2">
          <textarea
            className="w-full p-3 text-orange placeholder:text-orange placeholder:font-secondary placeholder:uppercase"
            placeholder="Message"
            name="message"
            value={formData.message}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="group single-input-holder col-span-1 m-2 flex flex-row bg-white items-center p-3 hover:bg-grey transition-all duration-350">
        <input
          type="submit"
          className="w-full bg-white text-orange font-secondary uppercase text-left transition-all duration-350 group-hover:text-white group-hover:bg-grey hover:cursor-pointer"
          value="Submit"
        />
      </div>
    </form>
      </section>
    </>
  );
};
